(function ($) {
    $(document).ready(function () {
        formInlinePosition();
        fieldsValidationCss();
    })

    $(window).smartresize(function () {
        formInlinePosition();
    });

    function formInlinePosition() {
        var formInline = $('.form_inline_container'),
            deformSection = $('.section_deform.inline'),
            formHeight = formInline.outerHeight(),
            mainContentHeight = $('.section.main_content').outerHeight(),
            formTopPosition = $('.section.main_content').position().top + mainContentHeight;

        formInline.css('top', formTopPosition);

        var slideshowHeight = $('.slideshow_container').outerHeight(),
            slideshowBottomPosition = $('.slideshow_container').position().top + slideshowHeight,
            deformMarginTop = formHeight - (slideshowBottomPosition - formInline.position().top);

        deformSection.css('padding-top', deformMarginTop);
    }


    function fieldsValidationCss() {
        jQuery.extend(jQuery.expr[':'], {
            invalid: function (elem, index, match) {
                var invalids = document.querySelectorAll(':invalid'),
                    result = false,
                    len = invalids.length;

                if (len) {
                    for (var i = 0; i < len; i++) {
                        if (elem === invalids[i]) {
                            result = true;
                            break;
                        }
                    }
                }
                return result;
            }
        });

        $('input').focusout(function () {
            if ($(this).is(':invalid')) {
                $(this).addClass('invalid');
            } else {
                $(this).removeClass('invalid');
            }
        })

        $('select').focusout(function () {
            if ($(this).is(':invalid')) {
                $(this).addClass('invalid');
            } else {
                $(this).removeClass('invalid');
            }
        })

        $('input[type=submit]').on('click', function () {
            if ($('input').is(':invalid')) {
                $('input:invalid').addClass('invalid');
            }
            if ($('select').is(':invalid')) {
                $('select:invalid').addClass('invalid');
            }
        });
    }
}(jQuery));